import React from 'react';
export function JealousTestimonials() {
  const reviews = [{
    quote: 'Andy and his team — especially DJ — were awesome. They showed up on time, were professional, and absolutely exceeded expectations. The quality speaks for itself.',
    author: 'Longevity Athletics',
    location: 'Phoenix Valley',
    initial: 'L'
  }, {
    quote: 'We had a huge oil mess in our garage and driveway from a botched oil change. Blue Cactus did an excellent job cleaning it all up. Highly recommend!',
    author: 'Marsha C.',
    location: 'Maricopa, AZ',
    initial: 'M'
  }, {
    quote: "It's amazing how much dirt came off the house and the driveway looks new. Windows are shining! Will recommend you all to friends and family!",
    author: 'Kendra A.',
    location: 'Phoenix Valley',
    initial: 'K'
  }];
  return <section className="w-full py-24 px-4 bg-white" data-id="element-350">
      <div className="max-w-7xl mx-auto" data-id="element-351">
        <div className="text-center mb-16" data-id="element-352">
          <p className="mb-3" style={{
          color: '#3B8AC4',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 700,
          fontSize: '13px',
          letterSpacing: '1px',
          textTransform: 'uppercase'
        }} data-id="element-353">
            CUSTOMER REVIEWS
          </p>
          <h2 className="mb-4" style={{
          color: '#1F2937',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontWeight: 800,
          fontSize: 'clamp(28px, 4vw, 36px)',
          letterSpacing: '-0.02em',
          lineHeight: 1.2
        }} data-id="element-354">
            Don't Just Take Our Word For It
          </h2>
          <p style={{
          color: '#4F5B69',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '16px'
        }} data-id="element-355">
            See why 150+ Phoenix Valley homeowners rate us 5 stars.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-356">
          {reviews.map((r, i) => <div key={i} className="flex flex-col justify-between p-8 rounded-[16px]" style={{
          backgroundColor: '#F8FAFB'
        }} data-id="element-357">
              <div data-id="element-358">
                <div className="mb-4" style={{
              color: '#FBB034',
              fontSize: '18px',
              letterSpacing: '2px'
            }} data-id="element-359">
                  ★★★★★
                </div>
                <p className="mb-8 italic" style={{
              color: '#4F5B69',
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontSize: '15px',
              lineHeight: 1.6
            }} data-id="element-360">
                  "{r.quote}"
                </p>
              </div>
              <div className="flex items-center gap-4" data-id="element-361">
                <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: '#3B8AC4'
            }} data-id="element-362">
                  <span style={{
                color: '#FFFFFF',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                fontWeight: 700,
                fontSize: '16px'
              }} data-id="element-363">
                    {r.initial}
                  </span>
                </div>
                <div data-id="element-364">
                  <p style={{
                color: '#1F2937',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                fontWeight: 700,
                fontSize: '14px'
              }} data-id="element-365">
                    {r.author}
                  </p>
                  <p style={{
                color: '#9CA3AF',
                fontFamily: '"Plus Jakarta Sans", sans-serif',
                fontSize: '13px'
              }} data-id="element-366">
                    {r.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}